import { UserState } from '../interface/MyInterfaces'
import { resolveCddrUniversityNameFromList } from '../sharedUtilities/reportUniversityName'

function syncCddrUniversityName(state: UserState, displayId) {
    const name = resolveCddrUniversityNameFromList(state.UniversityListDetailedDistrictReport, displayId);
    if (!name) return state;

    const newState = Object.assign({}, state);
    newState.report_university_name = name;
    newState.report_university_name_initial = name;
    return newState;
}

export default function (state: UserState = { isAuthenticated: 0}, action) {

    switch (action.type) {
        case "SET_USERNAME":
            var propertyName = action.payload.name;
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload.value;
            return newState;
        case "SHARE_LINK_HISTORY":
            propertyName = "share_link_history";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SHARED_LINK_CREATED":
            propertyName = "share_report_link";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SHARED_LINK_CLEARED":
            propertyName = "share_report_link";
            var newState = Object.assign({}, state);
            newState[propertyName] = "";

            return newState;
        case "UNIVERSITY_LIST_IMPACTFINDER":
            propertyName = "UniversityListImpactFinder";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
            
        case "UNIVERSITY_LIST_FACTSHEET":
            propertyName = "FactSheetList";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "UNIVERSITY_LIST_ECR":
            propertyName = "UniversityListECR";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "UNIVERSITY_LIST_STATEREPORT":
            propertyName = "UniversityListStateReport";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "UNIVERSITY_LIST_SPENDINGREPORT":
            propertyName = "UniversityListSpendingReport";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "UNIVERSITY_LIST_EMPLOYEEREPORT":
            propertyName = "UniversityListEmployeeReport";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "UNIVERSITY_LIST_SBEMPLOYEEREPORT":
            propertyName = "UniversityListSBEmployeeReport";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "UNIVERSITY_LIST_VENDORREPORT":
            propertyName = "UniversityListVendorReport";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "UNIVERSITY_LIST_VENDORREPORT2025":
            propertyName = "UniversityListVendorReport2025";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "UNIVERSITY_LIST_CTSAREPORT":
            propertyName = "UniversityListCTSAReport";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "UNIVERSITY_LIST_DETAILED_DISTRICT_REPORT":
            propertyName = "UniversityListDetailedDistrictReport";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return syncCddrUniversityName(newState, newState.report_display_id);
        case "REPORT_DISPLAY_ID_CHANGE":
            propertyName = "report_display_id";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return syncCddrUniversityName(newState, action.payload);
        case "REPORT_UNIVERSITY_NAME_CHANGE":
            propertyName = "report_university_name";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "REPORT_DISPLAY_ID_CHANGE_INITIAL":
            propertyName = "report_display_id_initial";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "REPORT_UNIVERSITY_NAME_CHANGE_INITIAL":
            propertyName = "report_university_name_initial";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "CHANGE_ONE_DISTRICT_REPORT_VINTAGE":
            propertyName = "report_vintage_one_district";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "CHANGE_PASSWORD":
            propertyName = "password";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload.value;
            newState["MessageToShow"] = "PasswordSuccessfullyChanged"
            return newState;
        case "SAVE_REPORT_VINTAGE_VENDOR":
            propertyName = "report_vintage_vendor";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload.report_vintage_vendor;
            return newState;
        case "SAVE_REPORT_VINTAGE_VENDOR2025":
            propertyName = "report_vintage_vendor2025";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload.report_vintage_vendor2025;
            return newState;
        case "ADD_EVENT":
            return state;
        case "LOGIN_SUCCESSFUL":
            return action.payload;
        case "LOGIN_FAILED":
            return action.payload;
        case "OPENREPORTS":
            return action.payload;
        case "FILETYPE_CHANGE":
            propertyName = "file_type";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "DOWNLOAD_DATA_FILES":
            propertyName = "downloadDataFileHref";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EMAIL_SUBMITTED":
            propertyName = "sharedLinkEmailSubmitted";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "LOGOUT":
        default:
            return state;
    }
}